/* eslint-disable react/prop-types */
import Modal from 'react-modal';
// import { deeplinkToApp } from '../helpers/utils';
import './index.scss';

function ModalBase({ modalIsOpen, setIsOpen, children }) {
  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    content: {
      maxWidth: '550px',
      borderRadius: '25px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 'auto',
      height: 'fit-content',
      overflow: 'visible',
    },
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            ...Modal.defaultStyles.overlay,
            backgroundColor: 'rgba(27, 27, 27, 0.75)',
            zIndex: 1001,
            alignItems: 'center',
          },
          content: { ...customStyles.content },
        }}
      >
        {children}
      </Modal>
    </div>
  );
}

export default ModalBase;
